import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import BookingManagement from './pages/BookingManagement';
import BookingList from './pages/BookingList';
import './index.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<BookingManagement />} />
          <Route path="/booking" element={<BookingManagement />} />
          <Route path="/bookings" element={<BookingList />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;